import styled from "styled-components";

export const Table = styled.table`
  border-collapse: collapse;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  font-size: 0.9em;
  width: 100%;
  height: fit-content;
`;

export const Theader = styled.thead`
  background: linear-gradient(135deg, #1a2e35 0%, #263654 100%);
  color: #ffffff;
  text-align: center;
  position: sticky;
  top: 0;
  height: 6vh;
  font-size: 1rem;
  z-index: 9;
`;

export const Theader2 = styled.thead`
  background: linear-gradient(135deg, #1a2e35 0%, #263654 100%);
  color: #ffffff;
  text-align: center;
  position: sticky;
  top: -1px;
  height: 6vh;
  font-size: 1rem;
  z-index: 9;
`;

export const Th = styled.th`
  padding: 2px 10px;
  text-align: center;
`;

export const Grup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 2rem;
  width: 100%;

  ::placeholder {
    color: #ffffff;
  }
`;

export const Tbody = styled.tbody`
  height: fit-content;
  overflow: scroll;
`;

export const Trbody = styled.tr`
  border-bottom: 1px solid #dddddd;
  height: 50px;
  &:nth-of-type(even) {
    background-color: #f3f3f3;
  }

  transition: all 0.2s;

  &:hover {
    background-color: grey;
    color: white;
    transform: scale(1.01);
  }

  .convenioTd {
    width: 5rem;
    max-width: 5rem;
  }
  .checkbox {
    width: 2rem;
  }
`;

export const Td = styled.td`
  padding: 10px 30px;
  min-height: 20vh;
  text-align: center;

  @media (max-width: 1000) {
    padding: 5px 15px;
  }
`;
